import script from "./CompositionWorkList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompositionWorkList.vue?vue&type=script&setup=true&lang=ts"

import "./CompositionWorkList.vue?vue&type=style&index=0&id=53b3b46e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b3b46e"]])

export default __exports__